import type { PartnerFulfillmentContext, PartnerSearchFulfillmentContextsParams } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export type PartnerFulfillmentContextLink = {
  assetType: 'origins';
  assetId: string;
  linkAction: 'link' | 'unlink';
};

export const fulfillmentContexts = {
  search: {
    queryKey: 'partner-management-service/fulfillment-contexts',
    configurationType: 'cached' as const,
    fn: async (params: PartnerSearchFulfillmentContextsParams = {}) => {
      const { data } = await GatewayAxiosClient.get<PartnerFulfillmentContext[]>(
        '/partner-management-proxy/api/v1/partners/fulfillmentContexts',
        { params },
      );

      return data;
    },
  },
  link: async ({
    fulfillmentContextId,
    payload,
  }: {
    fulfillmentContextId: string;
    payload: PartnerFulfillmentContextLink;
  }) => {
    await GatewayAxiosClient({
      method: payload.linkAction === 'link' ? 'PUT' : 'DELETE',
      url: `/partner-management-proxy/api/v1/partners/fulfillmentContexts/${fulfillmentContextId}/${payload.assetType}/${payload.assetId}`,
    });

    return {
      invalidateQueryKeys: [
        ['partner-management-service/fulfillment-contexts'],
        ['partner-management-service/fulfillment-contexts/id', fulfillmentContextId],
      ],
    };
  },
  bulkLinkContracts: async (payload: { fulfillmentContextIds: string[]; contractId: string; unlink: boolean }) => {
    await GatewayAxiosClient.post(`/ui-orchestration-proxy/api/v1/bulk/link-contract-to-contexts`, payload);
    return {
      invalidateQueryKeys: [
        ['partner-management-service/fulfillment-contexts'],
        ['partner-management-service/fulfillment-contexts/id', payload.contractId],
      ],
    };
  },
};
